import { AppCriticalityEnum, AppKindEnum } from 'src/graphql/schema';

export const KIND_OPTIONS = [
  {
    value: AppKindEnum.Single,
    label: 'Single application',
    description: 'One application',
  },
  {
    value: AppKindEnum.Suite,
    label: 'Application suite',
    description: 'Multiple applications your users rely on as one product',
  },
];

export const CRITICALITY_OPTIONS = [
  { value: AppCriticalityEnum.Standard, label: 'Standard' },
  { value: AppCriticalityEnum.Important, label: 'Important' },
  { value: AppCriticalityEnum.BusinessCritical, label: 'Business-critical' },
];

export const INDUSTRY_OPTIONS = [
  'Banking and capital markets',
  'Insurance',
  'Payments and fintech',
  'Healthcare and hospitals',
  'Pharmaceuticals and life sciences',
  'Government and public administration',
  'Defense and aerospace',
  'Energy and utilities',
  'Water and waste management',
  'Telecommunications',
  'Digital infrastructure and cloud services',
  'Transport and logistics',
  'Manufacturing and industrial',
  'Automotive',
  'Chemicals',
  'Food and agriculture',
  'Retail and e-commerce',
  'Technology and software',
  'Professional services',
  'Education and research',
  'Media and entertainment',
  'Real estate and construction',
  'Nonprofit and NGO',
  'Other',
];

export const SOFTWARE_TYPE_OPTIONS = [
  'Enterprise resource planning',
  'Customer relationship management',
  'Finance and accounting',
  'Payments and billing',
  'Human resources and payroll',
  'Analytics and business intelligence',
  'Data platform and warehouse',
  'AI and machine learning',
  'Developer and DevOps tooling',
  'Security and identity',
  'Infrastructure and hosting',
  'Middleware and integration',
  'Communication and collaboration',
  'Customer support',
  'Marketing and sales',
  'E-commerce platform',
  'Content management',
  'Supply chain and logistics',
  'Manufacturing and operations',
  'Clinical and patient systems',
  'Embedded and firmware',
  'Mobile application',
  'Industry-specific software',
  'Other',
];

export const JURISDICTION_OPTIONS = [
  'Multi-region',
  'Global / no fixed region',
  'Unknown / not disclosed',
  'Europe',
  'European Economic Area (EEA)',
  'United Kingdom',
  'North America',
  'Latin America',
  'Asia-Pacific',
  'Middle East',
  'Africa',
  'Other',
];

export const APP_COLORS = [
  { value: 'red-500', className: 'bg-red-500' },
  { value: 'orange-500', className: 'bg-orange-500' },
  { value: 'amber-500', className: 'bg-amber-500' },
  { value: 'lime-500', className: 'bg-lime-500' },
  { value: 'teal-500', className: 'bg-teal-500' },
  { value: 'blue-500', className: 'bg-blue-500' },
  { value: 'violet-500', className: 'bg-violet-500' },
  { value: 'pink-500', className: 'bg-pink-500' },
] as const;

export type IAppColor = (typeof APP_COLORS)[number]['value'];
